import { PortalHeaderItem, PortalHeaderItemType } from './menu.type';

/** Whether the menu item is active. */
export function isActiveRoute(item: PortalHeaderItem, path: string): boolean {
  if (item.type !== PortalHeaderItemType.Path) return false;
  const menuPath = item.id.startsWith('/') ? item.id : `/${item.id}`;
  return path === menuPath || (menuPath !== '/' && path.startsWith(menuPath + '/'));
}

/**
 * true if the given path should hide the header/sidebar.
 */
export function isPathHidden(path: string, fullUrl: string, hiddenPaths: string[] | undefined): boolean {
  if (!hiddenPaths?.length) {
    return fullUrl.includes('notfound');
  }
  if (hiddenPaths.includes(path)) return true;
  for (const hiddenPath of hiddenPaths) {
    if (path.includes(hiddenPath) || hiddenPath.includes(path)) return true;
  }
  if (fullUrl.includes('notfound')) return true;
  return false;
}

/**
 * true if the user has access to the menu item.
 */
export function hasAccessToItem(item: PortalHeaderItem, userRoles: string[]): boolean {
  if (item.hidden) return false;
  if (!item.requiredroles?.length) return true;
  return item.requiredroles.some((role) => userRoles.includes(role));
}
